module.exports = __webpack_public_path__ + "img/heart.fe84de39.jpg";